import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { queryattr: String }

  connect() {
  }

  pickDate(event) {
    const queryAttr = this.hasQueryattrValue ? this.queryattrValue : (this.data.get("queryattr") || "date")
    const dateValue = event.target.value
    if (dateValue) {
      const url = `${window.location.pathname}?${queryAttr}=${dateValue}`
      window.location.replace(url)
    }
  }
}
